<template>
  <div class="review-item">
    <div class="review-item-header">
      <div class="review-item-header-left">
        <ym-avatar class="user-avatar"
                   :avatar="item.user.avatar"
                   :name="item.user.name"
                   size="small"
                   lazy
        />
        <div class="user-info">
          <div class="name">
            <span>{{ item.user.name }}</span>
            <ym-img v-if="item.showFans"
                    class="tag"
                    :src="require('@/assets/img/course/tag_fans.png')"
            />
            <ym-img v-if="item.showVip"
                    class="tag vip"
                    :src="require('@/assets/img/course/tag_vip.png')"
            />
          </div>
          <div class="rate">
            <ym-icon v-for="rate in rateValue"
                     :key="rate"
                     class="icon-rate"
                     name="rate-fill"
                     color="#FEA500"
                     size="12"
            />
            <ym-icon v-for="rate in (5 - rateValue)"
                     :key="rate + 5"
                     class="icon-rate"
                     name="rate-fill"
                     color="#ccc"
                     size="12"
            />
          </div>
        </div>
      </div>
      <div class="review-item-header-right">
        <ym-img v-if="item.showChoice"
                class="review-item-header-right-tag"
                :src="require('@/assets/img/course/tag_message.png')"
        />
        <div class="review-item-header-right-like"
             :class="{ 'active': like }"
             @click="handleLike(item.id)"
             v-ym-report:COURSE_DETAIL_COMMENTLIKE_CLICK="{
               commentId: item.id,
               like: !like,
             }"
        >
          <ym-icon v-if="like"
                   class="icon"
                   name="yidianzan"
                   color="#57D1D1"
          />
          <ym-icon v-else
                   class="icon"
                   name="dianzan"
                   color="#ccc"
          />
          <span>{{ likeNum ? likeNum : '赞' }}</span>
        </div>
      </div>
    </div>
    <div class="review-item-content">{{ item.content }}</div>
    <div class="review-item-date">{{ item.time|formatTime('yyyy年MM月dd日') }}</div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';
  import { setCourseCommentLike } from '@/services/course';

  export default {
    name: 'ReviewItem',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        like: false,
        likeNum: 0,
      };
    },
    computed: {
      rateValue() {
        const { rating } = this.item;
        const result = Math.ceil(rating);
        if (result > 5) return 5;
        if (result < 0) return 0;
        return result;
      },
    },
    methods: {
      async handleLike(id) {
        this.like = !this.like;
        await setCourseCommentLike({ id, like: this.like });
        this.likeNum += this.like ? 1 : -1;
      },
    },
    created() {
      this.like = this.item.like;
      this.likeNum = this.item.likeNum;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .review-item {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-left: 40px;
    margin-right: 50px;
    padding-bottom: 60px;
    background-color: @color-white;
    &-header {
      display: flex;
      justify-content: space-between;
      &-left {
        display: flex;
        .user-avatar {
          flex-shrink: 0;
          margin-right: @size-small;
        }
        .user-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 70px;
          .name {
            display: flex;
            align-items: center;
            span {
              color: #222;
              font-size: 28px;
              font-weight: bold;
            }
            .tag {
              width: 60px;
              height: 28px;
              margin-left: 10px;
              &.vip {
                width: 138px;
              }
            }
          }
          .rate {
            display: flex;
            align-items: center;
            .icon-rate {
              margin-right: 2px;
            }
          }
        }
      }
      &-right {
        display: flex;
        height: 40px;
        &-tag {
          position: absolute;
          top: 100px;
          right: -10px;
          width: 100px;
          height: 90px;
        }
        &-like {
          display: flex;
          align-items: center;
          justify-content: center;
          word-break: keep-all;
          .icon {
            margin-right: 15px;
          }
          span {
            color: #cccccc;
            font-size: 28px;
          }
          &.active {
            span {
              color: #57D1D1;
            }
          }
        }
      }
    }
    &-content {
      padding-left: 90px;
      color: #222;
      font-size: 28px;
      margin-top: 20px;
      word-break: break-word;
    }
    &-date {
      padding-left: 90px;
      color: #999;
      font-size: 24px;
      margin-top: 10px;
    }
  }
</style>
